// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3tfZG","cell":"ColumnAccessor_cell__19kjk","firstCellAccent":"ColumnAccessor_firstCellAccent__vZLS9"};